import {MobileMenuItem} from './MobileMenuItem';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Mobile} from "../adaptive/Mobile";

interface MobileOnlyMenuProps {
    toggleVerticalMenu: () => void;
}
export const MobileOnlyMenu = ({toggleVerticalMenu}: MobileOnlyMenuProps) => {
    const {t} = useTranslation();

    return (
        <Mobile>
            <MobileMenuItem
                text={t('verticalMenuItems.rules')}
                linkTo="/sport/rules"
                toggleVerticalMenu={toggleVerticalMenu}
            />
            <MobileMenuItem
                text={t('verticalMenuItems.mySteps')}
                linkTo="/sport/my-bets"
                toggleVerticalMenu={toggleVerticalMenu}
            />
            <MobileMenuItem
                text={t('verticalMenuItems.results')}
                linkTo="/sport/results"
                toggleVerticalMenu={toggleVerticalMenu}
            />
        </Mobile>
    );
};
